angular.module('leanlaw').controller('SummaryTransactionsController', ['$scope', '$rootScope', '$q', '$window', '$filter', "$timeout", '$location', '$stateParams', '$state', "alerts", "userService", "ModalService", "leanLawAuth", "reportsService", "exportJson", "singleRequest", function ($scope, $rootScope, $q, $window, $filter, $timeout, $location, $stateParams, $state, alerts, userService, ModalService, leanLawAuth, reportsService, exportJson, singleRequest) {
  // $scope.filter is owned by sidebar
  $scope.sort = 'date';
  $scope.reverse = true;
  $scope.transactions = [];
  $scope.open = function (invoice) {
    if (invoice.accounting) {
      showInvoice(invoice);
    }
  };
  function showInvoice(invoice) {
    const url = `${leanLawAuth.domain}/v1/invoices/${invoice.id}/pdf`;
    $window.open(url);
  }
  function load() {
    if ($scope.activeTab !== "transactions") return;
    $scope.transactions = [];
    const query = queryFromFilter();
    if (!query) return;
    const loading = [];
    loading.push(singleRequest.apiCall("invoices").listInvoices(query).then(({
      invoices
    }) => {
      if (!invoices) return;
      invoices.forEach(invoice => {
        $scope.transactions.push({
          date: invoice.invoiceDate,
          referenceLabel: invoice.reference,
          invoices: [invoice],
          amount: invoice.totals.amount,
          matter: invoice.matter || {
            label: '-'
          },
          description: 'Invoice',
          invoice
        });
      });
    }));
    loading.push(singleRequest.apiCall("payments").listPayments(query).then(({
      payments
    }) => {
      if (!payments) return;
      payments.forEach(payment => {
        $scope.transactions.push({
          date: payment.date,
          amount: payment.amount,
          matter: payment.matter || {
            label: '-'
          },
          description: 'Payment',
          referenceLabel: payment.invoices.map(i => i.invoice.reference).join(', '),
          invoices: payment.invoices.map(i => i.invoice)
        });
      });
    }));

    // TODO load trust

    $scope.loading = true;
    $q.all(loading).catch(err => {
      alerts.error(err);
    }).finally(() => {
      $scope.loading = false;
    });
  }
  function queryFromFilter() {
    if (!$scope.filter) return; // Not ready yet
    if (!$scope.filter.filter) return;
    if (!$scope.cm) return;
    const query = reportsService.queryFromFilter($scope.filter);
    if ($scope.cm.matter) {
      query.matterId = $scope.cm.matter.id;
    } else {
      query.clientId = $scope.cm.client.id;
    }
    return query;
  }
  $scope.select = function (transaction) {};
  $scope.export = function () {
    const exp = $scope.transactions.map(a => {
      return {
        "Date": $filter("dateLogical")(a.date),
        "Type": a.description,
        "Invoice(s)": a.invoices?.map(i => {
          if (!i.accounting) {
            return i.state?.draft ? 'Draft' : i.state?.review ? 'Review' : i.state?.approved ? 'Approved' : '';
          }
          return i.reference;
        }).join(','),
        "Matter": a.matter.label,
        "Amount": $filter("amount")(a.amount),
        "Balance": $filter("amount")(a.invoice?.state?.balance)
      };
    });
    exportJson.downloadCsv(exp);
  };
  $scope.$on('commonFilterService-statechanged', (event, payload) => {
    load();
  });
  $scope.$on("report-sidebar-filterchange", (event, payload) => {
    load();
  });

  // Suffix is the active tab name for this view
  $scope.$on("summary-export-transactions", payload => {
    $scope.export();
  });
  $scope.$watch("cm", newValue => {
    load();
  });
  $scope.$watch("activeTab", newValue => {
    $timeout(load);
  });
}]);